import VueContentLoading from '../components/VueContentLoading.vue';

import VclCode from '../components/presets/Code.vue';
import VclList from '../components/presets/List.vue';
import VclTwitch from '../components/presets/Twitch.vue';
import VclFacebook from '../components/presets/Facebook.vue';
import VclInstagram from '../components/presets/Instagram.vue';
import VclBulletList from '../components/presets/BulletList.vue';
import VclTable from '../components/presets/Table.vue';

export default VueContentLoading;

export {
  VclCode,
  VclList,
  VclTwitch,
  VclFacebook,
  VclInstagram,
  VclBulletList,
  VclTable,
  VueContentLoading,
};



// WEBPACK FOOTER //
// ./src/core/components.js